import React, { useEffect, useState } from "react";
import api from "../../services/axios";

function AreaPatrocinadoresConteudoAdm(props) {
  const [salas, setSalas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let ativo = true;

    const handleSalas = async () => {
      setIsLoading(true);
      try {
        const respostaSalas = await api.post("/agenda-recepcao-conteudo", {
          tipo: ["conteudo_patrocinado", "conteudo_editorial"],
        });
        if (!ativo) return;
        if (respostaSalas.status === 200) {
          const auxSalas = (respostaSalas.data?.dados || []).map((s) => {
            const entregues = (s.participantes || []).filter((ap) => {
              return ap.presenca;
            });
            s.entregues = entregues;
            return s;
          });
          setSalas(auxSalas);
        }
      } catch (err) {
        console.error("Erro ao carregar cota conteúdo:", err);
        if (ativo) setSalas([]);
      } finally {
        if (ativo) setIsLoading(false);
      }
    };

    handleSalas();
    return () => {
      ativo = false;
    };
  }, []);

  if (isLoading || !salas?.length) return null;

  return (
    <section className="amd-cota" aria-label={`Cota ${props.cota}`}>
      <div className="amd-cota-header">
        <h2 className="amd-cota-title">{props.cota}</h2>
        <span className="apl-tag-plan">
          {salas.length} {salas.length === 1 ? "sala" : "salas"}
        </span>
      </div>

      <div className="amd-cota-grid">
        {salas.map((p) => {
          const total = p.participantes?.length ?? 0;
          const presentes = p.entregues?.length ?? 0;
          const sla =
            presentes !== 0 && total !== 0
              ? ((presentes / total) * 100).toFixed(2)
              : "0";
          return (
            <article key={p.id || p.nome} className="apl-card amd-sponsor-card">
              <div className="amd-sponsor-card__head">
                <h3 className="amd-sponsor-card__name">{p.nome}</h3>
              </div>
              <div className="apl-table-wrap">
                <table className="apl-table amd-sponsor-table">
                  <tbody>
                    <tr>
                      <td>Quantidade agendada</td>
                      <td className="amd-num">{total}</td>
                    </tr>
                    <tr>
                      <td>Presentes</td>
                      <td className="amd-num">{presentes}</td>
                    </tr>
                    <tr>
                      <td>SLA</td>
                      <td className="amd-num amd-num--sla">{sla} %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default AreaPatrocinadoresConteudoAdm;
